import { 
  UPDATE_WHEEL_PRIZE,
  UPDATE_WHEEL_SPIN_STATUS,
  WHEEL_SPINNING
} from "../actions/wheel";

const initialState = {
  spinning: false,
  prize: null,
  spun: false
}

export function s_wheel(state = initialState, action) {
// console.log('s_game', state);
  switch (action.type) {
    case UPDATE_WHEEL_PRIZE:
      return Object.assign({}, state, {prize: action.data});
    case UPDATE_WHEEL_SPIN_STATUS:
      return Object.assign({}, state, {spun: action.data});
    case WHEEL_SPINNING:
      return Object.assign({}, state, {spinning: action.data});
    default:
      return state;
  }
}
